import styled from "styled-components";

export const MainContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
  column-gap: 40px;
  width: 100%;
  max-width: 600px;

  form {
    width: 100%;
  }
`;
